module.exports = __webpack_public_path__ + "img/img-5.c4d8ce68.webp";